import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DiffFilledSvg from "@ant-design/icons-svg/es/asn/DiffFilled";
import AntdIcon from '../components/AntdIcon';
var DiffFilled = function DiffFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: DiffFilledSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(DiffFilled);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'DiffFilled';
}
export default RefIcon;